import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ShippingContainers.frontend.types'

@Injectable({ providedIn: 'root' })
export class ShippingContainers_container_assignment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { containerTypeId?: number, ownerId?: number, projectId?: number, materialId?: number }): Promise<{ reasons?: string[] }> 
  {
    let url = `${environment.backendUrl}api/ShippingContainers/functions/container_assignment_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

